import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { BookOpen, MagnifyingGlass } from '@phosphor-icons/react';
import { Input } from '@/components/ui/input';
import { Md } from '@/components/Md';

const API = process.env.REACT_APP_BACKEND_URL;

export default function RecursosPage() {
  const [resources, setResources] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState('');
  const [search, setSearch] = useState('');

  const fetch = useCallback(async () => {
    try {
      const [rRes, cRes] = await Promise.all([
        axios.get(`${API}/api/parent-resources${filter ? `?category=${filter}` : ''}`),
        axios.get(`${API}/api/parent-resources/categories`),
      ]);
      setResources(rRes.data); setCategories(cRes.data);
    } catch {}
  }, [filter]);
  useEffect(() => { fetch(); }, [fetch]);

  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const filtered = search ? resources.filter(r => norm(r.title).includes(norm(search)) || norm(r.content).includes(norm(search))) : resources;

  return (
    <div className="fade-in" data-testid="recursos-page">
      <div className="mb-5">
        <h2 className="font-heading font-medium text-xl text-brand-text">Recursos</h2>
        <p className="text-xs text-brand-muted mt-0.5">Informação e guias para pais</p>
      </div>
      <div className="relative mb-3">
        <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted" />
        <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Pesquisar..." className="pl-9 rounded-xl border-brand-border" />
      </div>
      <div className="flex gap-1.5 mb-4 overflow-x-auto pb-1">
        <button onClick={() => setFilter('')} className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap ${!filter ? 'bg-brand-green text-white' : 'bg-brand-bg text-brand-muted border border-brand-border'}`}>Todos</button>
        {categories.map(c => (
          <button key={c} onClick={() => setFilter(filter === c ? '' : c)} className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap ${filter === c ? 'bg-brand-green text-white' : 'bg-brand-bg text-brand-muted border border-brand-border'}`}>{c}</button>
        ))}
      </div>
      {filtered.length === 0 ? (
        <div className="text-center py-12"><BookOpen size={48} className="mx-auto text-brand-placeholder mb-4" weight="duotone" /><p className="text-brand-muted text-sm">Sem recursos disponíveis.</p></div>
      ) : (
        <div className="space-y-3">
          {filtered.map(r => (
            <div key={r.id} className="bg-white border border-brand-border rounded-2xl p-4" data-testid={`resource-${r.id}`}>
              <span className="text-[9px] bg-brand-bg text-brand-muted px-2 py-0.5 rounded-full">{r.category}</span>
              <h3 className="text-sm font-medium text-brand-text mt-1">{r.title}</h3>
              <Md as="div" className="text-xs text-brand-muted mt-1 leading-relaxed">{r.content}</Md>
              {r.images?.length > 0 && (
                <div className="flex gap-2 mt-2 overflow-x-auto">
                  {r.images.map((img, i) => <img key={i} src={`${API}/api/files/${img}`} alt="" className="w-32 h-24 object-cover rounded-xl" />)}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
